import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { Logo } from './Logo';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  const services = t.footer.services;
  return <footer className="w-full bg-[#1b3a5b] pt-20 pb-8" data-id="element-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-29">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-30">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-31">
            <div className="mb-6" data-id="element-32">
              <Logo variant="dark" data-id="element-33" />
            </div>
            <p className="text-blue-100 text-sm max-w-sm leading-relaxed" data-id="element-34">
              {t.footer.tagline}
            </p>
          </div>

          {/* Services Column */}
          <div data-id="element-35">
            <h4 className="text-white font-bold text-xs tracking-wider uppercase mb-6" data-id="element-36">
              {t.footer.servicesHeading}
            </h4>
            <ul className="space-y-3" data-id="element-37">
              {services.map((service, index) => <li key={index} data-id="element-38">
                  <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors" data-id="element-39">
                    {service}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-40">
            <h4 className="text-white font-bold text-xs tracking-wider uppercase mb-6" data-id="element-41">
              {t.footer.contactHeading}
            </h4>
            <ul className="space-y-4" data-id="element-42">
              <li data-id="element-43">
                <a href="mailto:Medinaproduction20@gmail.com" className="flex items-start gap-3 text-blue-200 hover:text-white transition-colors group" data-id="element-44">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0 text-brandOrange group-hover:text-white transition-colors" data-id="element-45" />
                  <span className="text-sm break-all" data-id="element-46">
                    Medinaproduction20@gmail.com
                  </span>
                </a>
              </li>
              <li data-id="element-47">
                <div className="flex items-start gap-3 text-blue-200" data-id="element-48">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-brandOrange" data-id="element-49" />
                  <span className="text-sm leading-relaxed" data-id="element-50">
                    {t.footer.location[0]}
                    <br data-id="element-51" />
                    {t.footer.location[1]}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-52">
          <p className="text-blue-200/60 text-xs" data-id="element-53">{t.footer.copyright}</p>
          <p className="text-blue-200/60 text-xs" data-id="element-54">{t.footer.signoff}</p>
        </div>
      </div>
    </footer>;
}